import React, { useState } from "react";
import PreCandidateListItem from "./PreCandidateListItem";
import PreCandidateHistory from "../history/preCandidateHistory";
import { usePrecandidateContext } from "../context/Context";
import Pagination from "../../../components/Pagination";
import ModalCreateContact from "../contact/ModalCreateContact";
import ModalDeletePrecandidate from "../delete/ModalDeletePrecandidate";
import ModalEditPrecandidate from "../edit/ModalEditPrecandidate";
import SortedHeader from "../../../components/Tables/SortedHeader";
import ModalAlertToCreateInterviewOrScreenCall from "../ModalAlertToCreateInterview";
import ModalDNASentSuccessfully from "../../Interview/InterviewOptions/ModalDNASentSuccessfully";
import { useTranslation } from "react-i18next";
import ModalError from "../error/ModalError";
import "../../styles/styles.scss";
import "../../styles/tables.scss";
import ModalSelectDNALanguage from "../SendDNA/ModalSelectDNALanguage";

const PreCandidateList = () => {
  const {
    preCandidateList,
    pageNumber,
    setPageNumber,
    totalPages,
    setSearchObject,
    searchObject,
    isPreCandidateLoading,
    modalErrorOpen,
    closeModalError,
    modalErrorRedirect,
    openDeletePreCandidateModal,
    setModalShow,
    setModalEditShow,
    precandidate,
    modalDeleteShow,
    setModalDeleteShow,
    setUpdatePreCandidateList,
    updatePreCandidateList,
    showModalDNASentSuccessfully,
    setShowModalDNASentSuccessfully,
    setShowCreteInterviewConfirmation,
    showCreteInterviewConfirmation,
    openCreateScreenCall,
    setOpenCreateScreenCall,
    setPageSize,
    preCandidateId
  } = usePrecandidateContext();

  const { t } = useTranslation();
  const [isNewApplication, setIsNewApplication] = useState(false);
  const [editModalTitle, setEditModalTitle] = useState("Edit pre-Candidate");
  const [headers, setHeaders] = useState([
    { label: t("Name"), field: "FullName" },
    { label: t("Email Address"), field: "EmailAddress" },
    { label: t("Mobile number"), field: "PhoneNumber" },
    { label: t("Tech Area"), field: "TechAreaDescription" },
    {
      label: t("Tech Role"),
      field: "TechRoleDescription",
      style: { paddingLeft: "10px", paddingRight: "10px" }
    },
    { label: t("Status"), field: "AvailabilityStatus" },
    { label: t("Next Contact"), field: "NextContact" },
    { label: t("Manager"), field: "ManagerName" },
    { label: t("Created on"), field: "CreatedDate" },
    { label: "" }
  ]);

  return (
    <div>
      <div className="table-wrap precandidate">
        {isPreCandidateLoading ? (
          <>
            <table className="table-responsive">
              <thead>
                <SortedHeader
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  headers={headers}
                  setHeaders={setHeaders}
                />
              </thead>
            </table>
          </>
        ) : (
          <>
            <table className="table-responsive">
              <thead>
                <SortedHeader
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  headers={headers}
                  setHeaders={setHeaders}
                />
              </thead>
              <tbody>
                {preCandidateList.map((item) => (
                  <PreCandidateListItem
                    key={item.id}
                    preCandidate={item}
                    setIsNewApplication={setIsNewApplication}
                    setEditModalTitle={setEditModalTitle}
                  />
                ))}
              </tbody>
            </table>
            {preCandidateList.length === 0 && (
              <div className="loader-wrapper">
                {t("No Pre-Candidates found.")}
              </div>
            )}
          </>
        )}
      </div>
      <div>
        <div>
          <Pagination
            totalPages={totalPages}
            setPageNumber={setPageNumber}
            pageNumber={pageNumber}
            setPageSize={setPageSize}
          />
        </div>
      </div>
      <ModalCreateContact />
      <ModalDeletePrecandidate
        precandidate={precandidate}
        modalDeleteShow={modalDeleteShow}
        setModalDeleteShow={setModalDeleteShow}
        setUpdatePreCandidateList={setUpdatePreCandidateList}
        updatePreCandidateList={updatePreCandidateList}
      />
      <ModalEditPrecandidate
        isNewApplication={isNewApplication}
        title={editModalTitle}
      />
      <PreCandidateHistory />
      <ModalAlertToCreateInterviewOrScreenCall
        isOpen={showCreteInterviewConfirmation}
        setIsOpen={setShowCreteInterviewConfirmation}
        isInterview={true}
      />
      <ModalAlertToCreateInterviewOrScreenCall
        isOpen={openCreateScreenCall}
        setIsOpen={setOpenCreateScreenCall}
        isInterview={false}
      />
      <ModalSelectDNALanguage />
      <ModalError
        modalErrorOpen={modalErrorOpen}
        closeModalError={closeModalError}
        modalErrorRedirect={modalErrorRedirect}
        openDeletePreCandidateModal={openDeletePreCandidateModal}
        setModalShow={setModalShow}
        setModalEditShow={setModalEditShow}
      />
      <ModalDNASentSuccessfully
        showModal={showModalDNASentSuccessfully}
        setShowModal={setShowModalDNASentSuccessfully}
      />
    </div>
  );
};

export default PreCandidateList;
